import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import CdxGovernanceReadiness from "@/pages/CdxGovernanceReadiness";

export const Route = createFileRoute("/en/cdx-governance-readiness")({
  head: () =>
    buildRouteHead("/en/cdx-governance-readiness", {
      title: "CDx Combined Study Governance Readiness Checklist | QbD Group",
      description:
        "Free governance readiness checklist for pharma sponsors and diagnostic partners planning a combined CDx study in Europe. Check where the pharma-IVD responsibility gap remains open.",
    }),
  component: CdxGovernanceReadiness,
});
